import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Mock1 from '../../../../public/assets/images/nawy-now/mobile-step-1.png';
import Mock2 from '../../../../public/assets/images/nawy-now/mobile-step-2.png';
import Mock3 from '../../../../public/assets/images/nawy-now/mobile-step-3.png';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

const StepsSection = ({
  formRef,
  propertiesRef
}: {
  formRef: React.RefObject<HTMLDivElement>;
  propertiesRef: React.RefObject<HTMLDivElement>;
}) => {
  const [activeStep, setActiveStep] = useState(1);
  const sliderActiveRef = useRef<HTMLDivElement>(null);
  const { locale } = useRouter();
  const { t } = useTranslation('nawy-now');
  const handleSlideChange = (swiper: any) => {
    setActiveStep(swiper.activeIndex + 1);
  };
  const handleClick = (ref: React.RefObject<HTMLDivElement>) => {
    if (!ref.current) return;
    const offset = 70;
    const elementPosition = ref?.current?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  const steps = [
    {
      title: t('title_step_1'),
      description: 'description_step_1',
      image: Mock1
    },
    {
      title: (
        <>
          {t('contact')}{' '}
          <span className="orange">
            {t('nawy')} {t('now')}
          </span>{' '}
          {t('consultant')}
        </>
      ),
      description: 'description_step_2',
      image: Mock2
    },
    {
      title: (
        <>
          {t('move')}{' '}
          {locale == 'en' && <span className="orange">{t('now')}</span>}
        </>
      ),
      description: 'description_step_3',
      image: Mock3
    }
  ];
  // if (locale == 'ar') steps.reverse();

  return (
    <Container>
      <div className="inner-content">
        <div className="steps-title container-fluid">
          {`${t('nawy')} ${t('now')} ${t('your_fastest_path')}`}
        </div>
        <div className="steps-details">
          <div className="steps-slider">
            <div
              className="steps-slider-active"
              style={{
                left:
                  locale == 'en' ? `${((activeStep - 1) * 100) / 3}%` : 'unset',
                right:
                  locale == 'ar' ? `${((activeStep - 1) * 100) / 3}%` : 'unset'
              }}
              ref={sliderActiveRef}
            ></div>
          </div>
          <div className="steps-swiper">
            <Swiper
              slidesPerView={1}
              onSlideChange={handleSlideChange}
              initialSlide={0}
              style={{ width: '100%' }}
              modules={[Autoplay]}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false
                // reverseDirection: locale === 'ar'
              }}
              dir={locale === 'ar' ? 'rtl' : 'ltr'}
            >
              {steps.map((step, idx) => (
                <SwiperSlide key={idx}>
                  <div className="step-card">
                    <div className="step-content container-fluid">
                      <div className="step-title">{step.title}</div>
                      <div className="step-description">
                        {t(step.description)}
                      </div>
                      {(idx == 0 && locale == 'en') ||
                      (idx == 2 && locale == 'ar') ? (
                        <button
                          className="step-action"
                          onClick={() => handleClick(propertiesRef)}
                        >
                          <span>{t('go_to_properties')}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M15.0615 12.8359L10.0032 17.8943L4.94486 12.8359"
                              stroke="#FF5E00"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 3.73438L10 17.7594"
                              stroke="#FF5E00"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      ) : idx == 1 ? (
                        <button
                          className="step-action"
                          onClick={() => handleClick(formRef)}
                        >
                          <span>{t('fill_form')}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M15.0615 12.8359L10.0032 17.8943L4.94486 12.8359"
                              stroke="#FF5E00"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 3.73438L10 17.7594"
                              stroke="#FF5E00"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="step-image">
                      <ImageWrapper
                        src={step.image}
                        alt={step.title.toString()}
                        width={295}
                        height={220}
                        style={{ objectFit: 'cover' }}
                        className="steps-image"
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  background: #f8f8f8;
  padding: 16px 0;
  .inner-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .steps-title {
    font-family: materialBold;
    color: #2c3138;
    font-size: 18px;
    line-height: 29px;
    text-transform: uppercase;
    width: 300px;
    margin: 0;
  }

  .swiper-slide {
    height: 100%;
  }
  .steps-details {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
    .steps-slider {
      width: calc(100% - 32px);
      margin: 0 auto;
      height: 2px;
      background: #dadada;
      position: relative;
      .steps-slider-active {
        background-color: #2c3138;
        position: absolute;
        top: 0;
        width: calc(100% / 3);
        height: 100%;
        transition: all 0.3s ease-in-out;
      }
    }
    .steps-swiper {
      .step-card {
        display: flex;
        flex-direction: column;
        gap: 8px;
        height: 100%;
        .step-content {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .step-title {
            font-family: materialMedium;
            font-size: 16px;
            color: #2c3138;
            line-height: 140%;
            .orange {
              color: #ff5e00;
            }
          }
          .step-description {
            color: #52565d;
            font-family: materialRegular;
            font-size: 12px;
            line-height: 150%;
            max-width: 80%;
          }
          .step-action {
            display: flex;
            align-items: center;
            gap: 4px;
            background: transparent;
            cursor: pointer;
            border: none;
            outline: none;

            span {
              color: #ff5e00;
              font-family: materialSemiBold;
              font-size: 12px;
              line-height: normal;
              text-transform: capitalize;
            }

            svg {
              width: 16px;
              height: 16px;
            }
          }
        }
        .step-image {
          width: 100%;
          /* overflow: hidden; */
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          img {
            border-radius: 10px;
          }
        }
      }
    }
  }
`;

export default StepsSection;
